import { productsSlugs } from 'constants/products';

import { conditionerPageContent as conditioner } from 'assets/content/productPages/conditioner';
import { curlCreamPageContent as curl_cream } from 'assets/content/productPages/curl_cream';
import { dryShampooPageContent as dry_shampoo } from 'assets/content/productPages/dry_shampoo';
import { hairMaskPageContent as hair_mask } from 'assets/content/productPages/hair_mask';
import { leaveinPageContent as leavein } from 'assets/content/productPages/leavein';
import { leaveInConditionerPageContent as leavein_conditioner } from 'assets/content/productPages/leavein_conditioner';
import { revampShampooPageContent } from 'assets/content/productPages/revamp_shampoo';
import { scalpMaskPageContent as scalp_mask } from 'assets/content/productPages/scalp_mask';
import { shampooPageContent as shampoo } from 'assets/content/productPages/shampoo';
import { stylingGelPageContent as styling_gel } from 'assets/content/productPages/styling_gel';
import { heroModule as supplement_core } from 'assets/content/productPages/supplement_core';

import { scalpSerumPageContent } from './scalp_serum';

export {
  hair_mask,
  scalp_mask,
  shampoo,
  conditioner,
  leavein,
  leavein_conditioner,
  dry_shampoo,
  curl_cream,
  supplement_core,
  styling_gel,
};

export const productPageContentBySlug = {
  [productsSlugs.SCALP_SERUM]: scalpSerumPageContent,
  [productsSlugs.SHAMPOO]: revampShampooPageContent,
};
